// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "config" + "." + "de6012e8" + ".chunk.js";
};